export interface Testimony {
    id: string;
    trainingId: string;
    title: string;
    subtitle: string;
    description?: string | null;
    image?: string | null;
    videoLink?: string | null;
    text?: string | null;
    tags?: string[];
    keywords?: string[];
    relatedTestimonyIds?: string[];
    rank?: number;
    status: "draft" | "available" | "unavailable";
    comments?: string | null;
    created?: string;
    updated?: string;
}

export type TestimonyFormData =
    & Omit<
        Testimony,
        | "id"
        | "created"
        | "updated"
        | "rank"
        | "image"
    >
    & {
        image?: string | File | null;
    };

export const emptyTestimony = (trainingId: string): TestimonyFormData => ({
    title: "",
    subtitle: "",
    description: null,
    trainingId: trainingId,
    image: null,
    videoLink: null,
    text: null,
    status: "draft",
    tags: [""],
    keywords: [""],
    comments: null,
});
